export default "__VITE_ASSET__Ei_aUnHjfvtGaZVPu0kL4g__"